import { render, staticRenderFns } from "./CustomerImportProgress.vue?vue&type=template&id=1b56c1f2&scoped=true&"
import script from "./CustomerImportProgress.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportProgress.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportProgress.vue?vue&type=style&index=0&id=1b56c1f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56c1f2",
  null
  
)

export default component.exports